export const defaultPeriodType = "articles_seen";
